/** Basic HTML escape for user-controlled fields embedded in notification email HTML. */
function escapeHtml(s) {
  if (s == null || s === '') return '';
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function row(label, value) {
  const v = value === undefined || value === '' || value == null ? '-' : escapeHtml(value);
  return `<tr><td style="padding: 8px 0; color: #6B7280; font-size: 14px;">${escapeHtml(label)}</td><td style="padding: 8px 0; color: #111827; font-size: 14px;">${v}</td></tr>`;
}

export function buildContactEmailHtml(data) {
  return `
            <div style="font-family: -apple-system, BlinkMacSystemFont, sans-serif; max-width: 600px; margin: 0 auto; padding: 24px;">
                <h2 style="color: #111827; font-size: 20px; margin-bottom: 20px;">New Contact Form Submission</h2>
                <table style="width: 100%; border-collapse: collapse;">
                    ${row('Name', data.name)}
                    ${row('Company', data.company)}
                    ${row('Role', data.role)}
                    ${row('Email', data.email)}
                    ${row('Phone', data.phone)}
                    ${row('Plants', data.plants)}
                    ${row('Exploring', data.exploring)}
                    ${row('Message', data.message)}
                </table>
                <p style="margin-top: 24px; color: #9CA3AF; font-size: 12px;">Sent from Mushin Technologies website</p>
            </div>
            `;
}

export function buildDemoEmailHtml(data) {
  return `
            <div style="font-family: -apple-system, BlinkMacSystemFont, sans-serif; max-width: 600px; margin: 0 auto; padding: 24px;">
                <h2 style="color: #111827; font-size: 20px; margin-bottom: 20px;">New Demo Booking Request</h2>
                <table style="width: 100%; border-collapse: collapse;">
                    ${row('Name', data.name)}
                    ${row('Company', data.company_name)}
                    ${row('Email', data.email)}
                    ${row('Contact', data.contact)}
                    ${row('Plant Location', data.plant_location)}
                    ${row('Requirement', data.requirement)}
                </table>
                <p style="margin-top: 24px; color: #9CA3AF; font-size: 12px;">Sent from Mushin Technologies website</p>
            </div>
            `;
}

export function getNotificationRecipient() {
  return process.env.REACT_APP_NOTIFICATION_TO || 'sales@mushinlabs.com';
}
